export const environment = {
  production: true,
  environment_name: 'production',
  release: '92f5554609773d6df50d633d302ffb5dd078fdcb',

  hmr: false,
  base_url: '/api/admin/v2/',
  iban_base_url: '/iban',
  apesign2_base_url: '/apesign2',
  merchantcenter_base_url: 'https://merchants.mankido.de/',
  places_base_url: '/maps',
  places_api_key: 'AIzaSyAqHc9aItV8T5eVE3VoInJjQOuyYnF-4Lo',
  websocket_url: 'wss://api.mankido.de/websocket',

  sentry_dsn: 'https://34299abc3a1c49311ca17756d8fd6adc@sentry.mankido.net/5',
  sentry_project_id: '5'
};
